module.exports = __webpack_public_path__ + "img/menu-cho-express.46bcb4c5.jpg";